/**
 * Mock data for when MAMP/local server is not available
 * Contains the complete lesson data structure as returned from rebusmetod.com API
 *
 * Ціна/телефон/порівняння беруться з єдиного джерела правди (тема config/pricing.json),
 * згенерованого в ../config/pricing.generated.json — НЕ дублюй значення тут.
 */
import pricing from "../config/pricing.generated.json";

export const mockLessonData = {
  "status": "ok",
  "tasks": {
    "cards": [
      {"id": "1", "templateId": "ChotyryPlus", "type": "info-page"},
      {"id": "2", "templateId": "YakHratysya", "type": "info-page"},
      {"id": "3", "syllables": "какиконанино", "type": "syllables"},
      {"id": "4", "syllables": "лалилілобава", "type": "syllables"},
      {"id": "5", "syllables": "рариріромапа", "type": "syllables"},
      {"id": "6", "syllables": "татитозасоя", "type": "syllables"},
      {"id": "7", "templateId": "ShchoDali", "type": "info-page"},
      {"id": "8", "type": "read", "word": "коза"},
      {"id": "9", "type": "read", "word": "коло"},
      {"id": "10", "type": "read", "word": "мама"},
      {"id": "11", "type": "read", "word": "риба"},
      {"id": "12", "type": "read", "word": "сова"},
      {"id": "13", "type": "read", "word": "тато"},
      {"id": "14", "type": "read", "word": "яма"},
      {"id": "15", "templateId": "Chudovo", "type": "info-page"},
      {"id": "16", "type": "read", "word": "валіза"},
      {"id": "17", "type": "read", "word": "калина"},
      {"id": "18", "type": "read", "word": "корова"},
      {"id": "19", "type": "read", "word": "ялина"},
      {"id": "20", "type": "read", "word": "малина"},
      {"id": "21", "type": "read", "word": "собака"},
      {"id": "22", "type": "read", "word": "сорока"},
      {"id": "23", "templateId": "VyajavlyayetsyaMozhemoITry", "type": "info-page"},
      {"id": "24", "templateId": "YakschoVazhkoZbahnutyPryntzyp", "type": "info-page"}
    ],
    "id": 1
  },
  "user": {
    "study": {
      "availableLesson": 48,
      "availableCard": 5,
      "paidLesson": 48,
      "currentLesson": 1,
      "strictLesson": 48
    },
    "callingName": "Ребусе",
    "normalName": "Ребусус",
    "childCallingName": "Лізо",
    "phone": "+380969703338",
    "email": "rebusmetod@gmail.com",
    "isAdmin": true,
    "isLoggedIn": true,
    "isSpecialOfferValid": false,
    "roundedBirthday": 1658959200,
    "remindersLeft": 2,
    "reminderType": "sms"
  },
  "globals": {
    "contactPhoneNumber": pricing.contactPhoneNumber,
    "maxFreeLesson": 5,
    "maxFreeCard": 58,
    "maxLesson": 48,
    "prices": pricing.prices,
    "comparisons": pricing.comparisons,
    "env": {
      "isProd": true,
      "isLS": false,
      "isLF": false
    },
    "childCallingName": null,
    "payments": {
      "ik_ia_u": "https://www.rebusmetod.com/?paiddownloads_ipn=interkassa",
      "ik_ia_m": "POST",
      "ik_suc_u": "https://www.rebusmetod.com/dyakuyemo-za-prydbannya/",
      "ik_fal_u": "https://www.rebusmetod.com/tranzaktsiya-obroblyayetsya/"
    }
  }
};

/**
 * Generate mock data for different lessons with variations
 */
export const generateMockLessonData = (lessonId = 1) => {
  const baseData = JSON.parse(JSON.stringify(mockLessonData));
  
  // Update lesson ID in tasks
  baseData.tasks.id = lessonId;
  
  // Update current lesson in user data
  baseData.user.study.currentLesson = lessonId;
  
  // Generate different cards for different lessons (basic variation)
  if (lessonId > 1) {
    const words = [
      ['коза', 'коло', 'мама', 'риба', 'сова', 'тато', 'яма'],
      ['валіза', 'калина', 'корова', 'ялина', 'малина', 'собака', 'сорока'],
      ['бабуся', 'дідусь', 'котик', 'песик', 'рибка', 'пташка', 'мишка'],
      ['хлопчик', 'дівчинка', 'вчитель', 'батьки', 'друзі', 'родина', 'школа'],
      ['читання', 'письмо', 'математика', 'малювання', 'спорт', 'музика', 'танці']
    ];
    
    const lessonWords = words[(lessonId - 1) % words.length] || words[0];
    
    // Update read cards with lesson-specific words
    baseData.tasks.cards.forEach((card, index) => {
      if (card.type === 'read' && lessonWords[index % lessonWords.length]) {
        card.word = lessonWords[index % lessonWords.length];
      }
    });
  }
  
  return baseData;
};